import * as API from './index'

export default {
    login: params => {
        return API.POST('/api/Auth/Login', params)
    },
    validateFindPassword:params=>{
        return API.POST('/api/Auth/ValidateFindPassword', params)
    },
    changePassword:params=>{
        return API.POST('/api/Auth/ChangePassword', params)
    },
    refreshToken: params => {
        return API.POST('/api/Auth/RefreshToken', params)
    }
}


// WEBPACK FOOTER //
// ./src/apis/user.js